import { gql } from '@apollo/client'

export const GET_THEATRICAL_USER_PREFERENCES = gql`
  query GetTheatricalUserPreferences {
    theatricalUserPreferences {
      id
      autobookEnabled
      optInStatus
      timezone
      phoneNumber
      theaterPreferences {
        id
        priority
      }
      dayPreferences {
        day
        timeRanges {
          start
          end
        }
      }
      preferredVenues {
        id
        name
        providerId
        vendorLogo {
          cloudinaryPath
        }
        phone
        addressText
        address {
          line
          city
          countryCode
          zipCode
        }
      }
    }
  }
`
